export class ProductGroup {
    ActivityTC: string;
    ObjectTypeTC: string;
    DamageCauseTC: string;
    CoverageTC: string;
    ProductTypeTC: string;
    PreviousActivityTC?: any;

    public constructor(init?: Partial<ProductGroup>) {
        Object.assign(this, init);
    }
}
